export default __webpack_public_path__ + "static/media/Vietnam.af61d755.svg";